import * as React from 'react';
import { SingleNumberFilterEdit } from '.';
import { NumberFilterEditProps } from '../providers/SingleValue';

/**
 * Configures a single decimal value in a filter
 */
class SingleDecimalFilterEdit extends React.PureComponent<NumberFilterEditProps> {
	constructor(props) {
		super(props);
	}

	public render() {
		return <SingleNumberFilterEdit {...this.props} step="0.01" />;
	}
}

export default SingleDecimalFilterEdit;
